import React from "react";
import { useApp } from "@/context/AppContext";
import { weekendRange } from "@/lib/constants";

export default function QuickFilters({ value, onApply, onLocate }) {
  const { t } = useApp();
  const we = weekendRange();
  const gl = (value.genre || "").split(",").filter(Boolean);
  const hasG = g => gl.includes(g);
  const toggleG = g => (hasG(g) ? gl.filter(x => x !== g) : [...gl, g]).join(",");
  const chips = [
    { id: "weekend", label: t("thisWeekend"), active: value.date_from === we.date_from && value.date_to === we.date_to,
      run: a => onApply(a ? { date_from: "", date_to: "" } : we), sep: true },
    { id: "near", label: t("nearMe"), active: !!value.nearMe, run: onLocate, sep: true },
    { id: "alldayer", label: t("types.alldayer"), active: value.event_type === "alldayer", run: a => onApply({ event_type: a ? "" : "alldayer" }) },
    { id: "allnighter", label: t("types.allnighter"), active: value.event_type === "allnighter", run: a => onApply({ event_type: a ? "" : "allnighter" }) },
    { id: "weekender", label: t("types.weekender"), active: value.event_type === "weekender", run: a => onApply({ event_type: a ? "" : "weekender" }), sep: true },
    { id: "northern", label: t("genres.northern_soul"), active: hasG("northern_soul"), run: () => onApply({ genre: toggleG("northern_soul") }) },
    { id: "modern", label: t("genres.modern_soul"), active: hasG("modern_soul"), run: () => onApply({ genre: toggleG("modern_soul") }) },
  ];

  return (
    <div className="flex items-center flex-wrap justify-center gap-1.5 md:gap-2 py-1 -mx-2 md:mx-0" data-testid="quick-filters">
      {chips.map((c, i) => (
        <React.Fragment key={c.id}>
          <button type="button" data-testid={`quick-${c.id}`} onClick={() => c.run(c.active)}
            className={`gg-chip !py-2 !px-2 md:!px-3 whitespace-nowrap min-h-[36px] inline-flex items-center gap-1.5 ${c.active ? "gg-chip-active" : "hover:bg-muted"}`}>{["alldayer", "allnighter", "weekender"].includes(c.id) && <span aria-hidden="true" className={`inline-block w-1.5 h-1.5 gg-type-dot-${c.id}`} />}{c.label}</button>
          {c.sep && i < chips.length - 1 && <span aria-hidden="true" className="hidden md:block shrink-0 w-px h-5 bg-foreground/25 mx-1" data-testid="quick-sep" />}
        </React.Fragment>
      ))}
    </div>
  );
}
